import {
  fetchCreateCpdDraft,
  TCreateCpdDraftRequest,
  TCreateCpdDraftResponse,
} from '../../../repositories/cpd/v1/create-cpd-draft';
import { IDealsLeadFormValues } from '../../../types/dealsForm';
import { TThunkAction } from '../../../types/redux';

/**
 * Отправляет заявку «Циан Сделки» в create-cpd-draft:
 * телефон, регион и статья как источник лида.
 */
export const submitDealsLead = ({ phone, regionId }: IDealsLeadFormValues): TThunkAction<Promise<number | false>> => {
  return async (_dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    try {
      const parameters: TCreateCpdDraftRequest = {
        phone,
        regionId: regionId == null ? undefined : Number(regionId),
        source: 'cpdJournal',
      };

      const { statusCode, response }: TCreateCpdDraftResponse = await fetchCreateCpdDraft({
        httpApi,
        parameters,
      });

      if (statusCode === 200) {
        return response.cpdDraftId;
      }

      return false;
    } catch (error) {
      logger.error(error instanceof Error ? error : new Error(String(error)), {
        domain: 'actions.submitDealsLead',
      });

      return false;
    }
  };
};
